import {type FC, useState} from 'react';
import {EditButton} from './EditButton';
import {InputFreeTextarea} from './InputFreeTextarea';

const UserMessage: FC<{
  message: string;
  editing: boolean;
  editClick: () => void;
}> = ({message, editing, editClick}) => {
  return (
    <div className="flex w-full items-end justify-end gap-8">
      <EditButton editing={editing} editClick={editClick} />
      <div className="relative bg-background text-black-1 whitespace-pre-wrap p-16 rounded-16 shadow-card max-w-[75%] pc:max-w-[50%]">
        {message}
        <div className="absolute top-1/2 right-[-8px] transform -translate-y-1/2 w-0 h-0 border-t-[12px] border-t-transparent border-b-[12px] border-b-transparent border-l-[10px] border-l-background" />
      </div>
    </div>
  );
};

type FreeTextMessage = {
  index: number;
  selectedOptions: string[];
  handleSelectOption: (value: string, index?: number) => void;
  updateEditingState: (index: number, editing: boolean) => void;
};

export const FreeTextMessage: FC<FreeTextMessage> = ({
  index,
  selectedOptions,
  handleSelectOption,
  updateEditingState,
}) => {
  const [editing, setEditing] = useState(false);
  const [textInput, setTextInput] = useState('');

  return (
    <>
      {selectedOptions[index] !== undefined && (
        <div className="mt-16 flex gap-8 justify-end items-center">
          <UserMessage
            message={selectedOptions[index]}
            editing={editing}
            editClick={() => {
              setEditing(!editing);
              setTextInput(selectedOptions[index] ?? '');
              updateEditingState(index, !editing);
            }}
          />
        </div>
      )}
      {(selectedOptions[index] === undefined || editing) && (
        <div className="mt-16">
          <InputFreeTextarea
            textInput={textInput}
            editing={editing}
            setTextInput={setTextInput}
            sendClick={() => {
              if (editing) {
                handleSelectOption(textInput, index);
              } else {
                handleSelectOption(textInput);
              }

              setTextInput('');
              setEditing(false);
              updateEditingState(index, false);
            }}
          />
        </div>
      )}
    </>
  );
};
